import {
  INotificationsSettingsRequest,
  INotificationsSettingsResponse,
  IPreferencesSettingsRequest,
  IPreferencesSettingsResponse,
  IProfileSettingsRequest,
  IProfileSettingsResponse,
  ISettingsResponse,
} from "../contracts/Settings";
import { getDataAsync, postDataAsync, putDataAsync } from "../ZeosApiExecutor";
import { ISettingsCollection } from "./interfaces/ISettings";

const settingsPrefix = "/Settings";

export const Settings: ISettingsCollection = {
  getSettingsAsync: async () => {
    const response = await getDataAsync<ISettingsResponse>(settingsPrefix, "");
    return response;
  },
  updateProfileAsync: async (request: IProfileSettingsRequest) => {
    const response = await putDataAsync<IProfileSettingsResponse>(
      `${settingsPrefix}/Profile`,
      request
    );
    return response;
  },
  updateNotificationsAsync: async (request: INotificationsSettingsRequest) => {
    const response = await putDataAsync<INotificationsSettingsResponse>(
      `${settingsPrefix}/Notifications`,
      request
    );
    return response;
  },
  updatePreferencesAsync: async (request: IPreferencesSettingsRequest) => {
    const response = await putDataAsync<IPreferencesSettingsResponse>(
      `${settingsPrefix}/Preferences`,
      request
    );
    return response;
  },
  requestPasswordResetAsync: async () => {
    const response = await postDataAsync<string>(
      `${settingsPrefix}/Security/PasswordReset`,
      {}
    );
    return response;
  },
};
